/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ask_A_QuestionInputs */

const en_ask_a_question = /** @type {(inputs: Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask a Question`)
};

const es_ask_a_question = /** @type {(inputs: Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz una pregunta`)
};

const fr_ask_a_question = /** @type {(inputs: Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poser une question`)
};

const de_ask_a_question = /** @type {(inputs: Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Frage stellen`)
};

const ja_ask_a_question = /** @type {(inputs: Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`質問する`)
};

const zh_ask_a_question = /** @type {(inputs: Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提出问题`)
};

const ar_ask_a_question = /** @type {(inputs: Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطرح سؤالاً`)
};

const id_ask_a_question = /** @type {(inputs: Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajukan Pertanyaan`)
};

const it_ask_a_question = /** @type {(inputs: Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai una Domanda`)
};

const ru_ask_a_question = /** @type {(inputs: Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задать вопрос`)
};

const pt_ask_a_question = /** @type {(inputs: Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma Pergunta`)
};

const ko_ask_a_question = /** @type {(inputs: Ask_A_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`질문하기`)
};

/**
* | output |
* | --- |
* | "Ask a Question" |
*
* @param {Ask_A_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ask_a_question = /** @type {((inputs?: Ask_A_QuestionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ask_A_QuestionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ask_a_question(inputs)
	if (locale === "es") return es_ask_a_question(inputs)
	if (locale === "fr") return fr_ask_a_question(inputs)
	if (locale === "de") return de_ask_a_question(inputs)
	if (locale === "ja") return ja_ask_a_question(inputs)
	if (locale === "zh") return zh_ask_a_question(inputs)
	if (locale === "ar") return ar_ask_a_question(inputs)
	if (locale === "id") return id_ask_a_question(inputs)
	if (locale === "it") return it_ask_a_question(inputs)
	if (locale === "ru") return ru_ask_a_question(inputs)
	if (locale === "pt") return pt_ask_a_question(inputs)
	return ko_ask_a_question(inputs)
});